import StaffManagementCheckInSetupForm from "./staff-management-check-in-setup-form";

export default StaffManagementCheckInSetupForm;

